import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Button } from 'reactApp/sections/Nestle/Button/Button';
import { sendNestleLandingAnalytics, sendNestleLandingTmrGoal } from 'reactApp/sections/Nestle/NestleLanding.analytics';
import { PrizeCard } from 'reactApp/sections/Nestle/PrizeCard/PrizeCard';

import styles from './PrizeInfoBlock.css';

interface Props {
    isPaid?: boolean;
    onFillFormAgain: () => void;
    scrollToTariffs: () => void;
    scrollToPets: () => void;
}

export const PrizeInfoBlock = memo(({ isPaid, onFillFormAgain, scrollToTariffs, scrollToPets }: Props) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const activeUserEmail = useSelector(UserSelectors.getEmail);

    useEffect(() => {
        if (!isPaid) {
            sendNestleLandingTmrGoal('participation-window-show');
        }
    }, []);

    const onBiggerPrize = useCallback(() => {
        sendNestleLandingTmrGoal('click-bigger-prize-button');
        sendNestleLandingAnalytics({
            eventCategory: 'click',
            action: 'click-bigger-prize-button',
        });
        scrollToTariffs();
    }, [scrollToTariffs]);

    const onHaveOnMorePet = useCallback(() => {
        sendNestleLandingTmrGoal('click-another-pet-button');
        sendNestleLandingAnalytics({
            eventCategory: 'click',
            action: 'click-another-pet-button',
        });
        onFillFormAgain();
    }, [onFillFormAgain]);

    return (
        <div className={styles.container}>
            <Spacing size={isMobile ? 20 : 80} />
            <div
                className={classNames(styles.root, {
                    [styles.root_mobile]: isMobile,
                })}
            >
                <div className={styles.card}>
                    {isPaid ? (
                        <PrizeCard title="и приз побольше" isMobile={isMobile} size={isMobile ? 'large' : 'medium'} />
                    ) : (
                        <PrizeCard
                            isBlue
                            title="1 000 ₽"
                            description="на подарки для питомца и себя"
                            isMobile={isMobile}
                            size={isMobile ? 'large' : 'medium'}
                        />
                    )}
                </div>
                <div className={styles.info}>
                    <div className={styles.title}>{isPaid ? <>Шанс выиграть приз побольше&nbsp;— ваш</> : 'Вы участвуете в розыгрыше'}</div>
                    <Spacing size={isMobile ? 10 : 16} />
                    {isPaid ? (
                        <>
                            <div className={styles.text}>
                                Прислали письмо со вторым уникальным номером для&nbsp;розыгрыша на почту {activeUserEmail}
                            </div>
                            <Spacing size={16} />
                            <div className={styles.text}>
                                Если есть ещё один питомец — сделайте карточку и для него. Поумиляться на других участников можно в группе
                                Вконтакте
                            </div>
                        </>
                    ) : (
                        <div className={styles.text}>
                            Отправили письмо с карточкой любимки и уникальным номером для&nbsp;розыгрыша на почту {activeUserEmail}
                        </div>
                    )}

                    <Spacing size={isMobile ? 8 : 24} />
                    {isPaid ? (
                        <div className={styles.buttons}>
                            <Button text="У меня есть ещё один питомец" isBlue={isMobile} onClick={onHaveOnMorePet} />
                            <Button text="Поглядеть на других любимок" onClick={scrollToPets} />
                        </div>
                    ) : (
                        <div className={styles.buttons}>
                            <Button text="Хочу приз побольше" isBlue={isMobile} onClick={onBiggerPrize} />
                            <Button text="У меня есть ещё один питомец" onClick={onHaveOnMorePet} />
                        </div>
                    )}
                </div>
            </div>
            <Spacing size={isMobile ? 12 : 80} />
        </div>
    );
});

PrizeInfoBlock.displayName = 'PrizeInfoBlock';
